// extracted by mini-css-extract-plugin
export default {"cls1":"WXnmBcHPdigxaJlysILX","cls2":"UxyAdVRuEltjfY4Lv7ve WXnmBcHPdigxaJlysILX"};